export const RequiredTableCols = {
    DRAG: "drag",
    ROW_NUMBER: "rowNumber",
    ACTIONS: "actions",
} as const;
